<header class="top-header">
  <div class="top-header__left">
    <button class="top-header__toggle" type="button" (click)="toggleSidebar()"
      [attr.aria-label]="sidebarCollapsed() ? 'Open navigation' : 'Close navigation'"
      [attr.aria-expanded]="!sidebarCollapsed()">
      <i class="bi" [class.bi-list]="sidebarCollapsed()" [class.bi-x]="!sidebarCollapsed()"></i>
    </button>
    <span class="top-header__title">Zen Analytics</span>
  </div>
  <div class="top-header__right">
    <div class="top-header__profile">
      <div class="top-header__avatar" (click)="toggleProfileMenu()"
        [attr.aria-label]="'Signed in as ' + profileInitials()">
        {{ profileInitials() }}
      </div>
      <div class="top-header__menu" *ngIf="isProfileMenuOpen">
        <button class="top-header__menu-item" type="button" (click)="logout()">
          <i class="bi bi-box-arrow-right"></i> Logout
        </button>
      </div>
    </div>
  </div>
</header>